import { pgApiClient } from '../../../config/axiosClient'

const postCloudinaryCustomImage = async (imageData: string) => {
    const { data } = await pgApiClient.post(
        'https://api.Cloudinary.com/v1_1/gift-card-granny/image/upload',
        {
            file: imageData,
            upload_preset: 'pgsite_custom_design_uploads',
        }
    )
    return data
}

export default postCloudinaryCustomImage
